import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

import { request, reportErrorToHoneybadger } from '../../helpers/Requests'

import ModalContainerTrigger from '../shared/ModalContainerTrigger'
import { adminUser, hideElementForNonAdmins, renderErrors } from '../../utilities/Forms.js'

import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';

class MobileEnrolment extends Component {

  constructor(props) {
    super(props);

    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleTabChange = this.handleTabChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleRemove = this.handleRemove.bind(this);

  }

  state = {
    autumna_integrations: [],

    tabIndex: 0,

    showModal: false,
    one_time_code: "",

    loaded: true,
    unauthorized: "",
    error: "",
    errors: ""
  };

  openModal(event) {
    this.setState({ showModal: true })
  }

  closeModal(event) {
    this.setState({
      showModal: false,
      one_time_code: "",
      errors: ""
    })
  }

  handleChange(event) {
    let name = event.target.name;
    let value = event.target.value;

    this.setState({[name]: value});
  }

  handleTabChange(index) {
    this.setState({ tabIndex: index });
  }

  handleSubmit() {
    const json = JSON.stringify({
      "autumna_integration": {
        "one_time_code": this.state.one_time_code
      }
    })

    request('POST', `/v1/a/autumna_integrations`, json, () => {this.setState({ unauthorized: true })})
      .then(data => {
        sessionStorage.setItem("updateSuccess", `Autumna Integration created successfully!\nYou can now go to your Locations configurations forms to enable sending Feedback data from each Location individually.`);
        this.props.updatePopupCallback(Math.random())

        this.setState({ autumna_integrations: data })
        this.closeModal()
      })
      .catch(error => {
        reportErrorToHoneybadger(error)

        if (error instanceof Error) {
          this.setState({ updating: false, error: error })
        }
        else {
          this.setState({ updating: false, errors: error })
        }
      })
  }

  handleRemove(event) {
    const id = event.currentTarget.id

    request('DELETE', `/v1/a/autumna_integrations/${id}`, null, () => {this.setState({ unauthorized: true })})
      .then(data => {
        sessionStorage.setItem("updateSuccess", `Autumna Integration removed succesfully!\nLocations already set up to submit Feedback will continue to do so until their integrations are disabled on their individual configuration forms.`);
        this.props.updatePopupCallback(Math.random())

        this.setState({ autumna_integrations: data })
      })
      .catch(error => {
        reportErrorToHoneybadger(error)

        if (error instanceof Error) {
          this.setState({ updating: false, error: error })
        }
        else {
          this.setState({ updating: false, errors: error })
        }
      })
  }

  render() {
    const { autumna_integrations, tabIndex, showModal, one_time_code, loaded, unauthorized, error, errors } = this.state;

    if (localStorage.license === "entry") {
      return <Redirect to="/upgrade" />
    }

    if (unauthorized) {
      return <Redirect to="/login"/>
    }

    if (error) {
      return <div>{error.message}</div>;
    }

    if (loaded === false) {
      return <p>Loading ...</p>;
    }

    if (loaded) {
      return (
        <div>
          <div>
            <div className="top-text">
              <p>This is the Integrations page. Here you can manage 3rd party integrations.</p>
            </div>
          </div>

          <Tabs selectedIndex={tabIndex} onSelect={value => this.handleTabChange(value)}>
            <TabList>
              <Tab key={0}>Autumna</Tab>
            </TabList>

            <TabPanel key={0}>
              <div className={`button new-button ${hideElementForNonAdmins()}`} onClick={this.openModal}>New Autumna Integration</div>

              <ModalContainerTrigger closeName="Cancel" showModal={showModal} openModal={this.openModal} closeModal={this.closeModal} >
                <div className="settings">
                  <div>Please enter your one time integration code from Autumna here.</div>
                  <br/>
                  <div className="bottom-margin">Afterwards, you must go to your Locations configurations forms to enable sending Feedback data from each Location individually to complete the setup process.</div>

                  <div className="center-text">
                    { renderErrors(errors, 'one_time_code', "") }
                  </div>
                  <div className="center-two-buttons">
                    <input className="bottom-margin" type="text" name="one_time_code" value={one_time_code} onChange={this.handleChange} placeholder="Enter your one-time code" />
                    <button className="button" onClick={this.handleSubmit}>Submit</button>
                  </div>
                </div>
              </ModalContainerTrigger>

              <div className="table big-table">
                <div className="tr heading">
                  <div className="th">Created at</div>
                  <div className="th">Created by</div>
                  {adminUser() && <div className="th">Remove</div>}
                </div>
                {autumna_integrations.map((autumna_integration) => (
                  <div key={autumna_integration.id} className="tr">
                    <div className="td">{autumna_integration.created_at}</div>
                    <div className="td">{autumna_integration.user_name}</div>
                    {adminUser() && <div className="td center"><div id={autumna_integration.id} className="small button" onClick={this.handleRemove}>Remove</div></div>}
                  </div>
                ))}
              </div>
              {autumna_integrations.length === 0 && (
                <div className="long-tr">
                  <div className="long-td">
                    No integrations found.
                  </div>
                </div>
              )}
            </TabPanel>
          </Tabs>
        </div>
      )
    }
  }

  componentDidMount() {
    request('GET', `/v1/a/autumna_integrations`, null, () => {this.setState({ unauthorized: true })})
      .then(data => {
        this.setState({
          autumna_integrations: data,
          loaded: true
        })
      })
      .catch(error => {
        reportErrorToHoneybadger(error)

        this.setState({ error, loaded: true })
      })
  }
}

export default MobileEnrolment;
